// Module
var code = "<new-event-schedule classrooms=\"classrooms\" event-default-id=\"eventDefaultId\" event-defaults=\"eventDefaults\" event-types=\"eventTypes\" gym=\"gym\" on-close=\"close()\" styles=\"styles\" time=\"time\"></new-event-schedule>\n";
// Exports
module.exports = code;